import script from "./audio.vue?vue&type=script&setup=true&lang=js"
export * from "./audio.vue?vue&type=script&setup=true&lang=js"

import "./audio.vue?vue&type=style&index=0&id=26c64b14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c64b14"]])

export default __exports__